import { z } from 'zod';
import { defineEndpoint } from '../define';
import { ReleaseDetailSchema } from './shapes';

export const getRelease = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({ data: ReleaseDetailSchema }),
});
